import { defineMessages } from "react-intl";

export const scope = "components.AlpacaActivitiesScroll";

export const messages = defineMessages({
  sell: {
    id: `${scope}.sell`,
    defaultMessage: "Venta {symbol}",
  },
  buy: {
    id: `${scope}.buy`,
    defaultMessage: "Inversión {symbol}",
  },
  amount: {
    id: `${scope}.amount`,
    defaultMessage: "Monto",
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: "Estado",
  },
  received: {
    id: `${scope}.received`,
    defaultMessage: "Recibiste",
  },
  sended: {
    id: `${scope}.sended`,
    defaultMessage: "Enviaste",
  },
  tid: {
    id: `${scope}.tid`,
    defaultMessage: "ID Movimiento",
  },
  rejected: {
    id: `${scope}.rejected`,
    defaultMessage: "Rechazado",
  },
  pending: {
    id: `${scope}.pending`,
    defaultMessage: "Pendiente",
  },
  succeded: {
    id: `${scope}.succeded`,
    defaultMessage: "Aprobado",
  },
  receipt: {
    id: `${scope}.receipt`,
    defaultMessage: "VER COMPROBANTE",
  },
  goBack: {
    id: `${scope}.goBack`,
    defaultMessage: "Volver",
  },
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: "Depósito",
  },
  withdrawal: {
    id: `${scope}.withdrawal`,
    defaultMessage: "Rescate",
  },
  adjustment: {
    id: `${scope}.adjustment`,
    defaultMessage: "Ajuste",
  },
  acatTransfer: {
    id: `${scope}.acatTransfer`,
    defaultMessage: "ACAT transferencia",
  },
  transfer: {
    id: `${scope}.transfer`,
    defaultMessage: "Transferencia",
  },
  payOnMoney: {
    id: `${scope}.payOnMoney`,
    defaultMessage: "Pago en dinero",
  },
  cashWitdrawable: {
    id: `${scope}.cashWitdrawable`,
    defaultMessage: "Retiro efectivo",
  },
  dividend: {
    id: `${scope}.dividend`,
    defaultMessage: "Dividendos",
  },
  dividendExempt: {
    id: `${scope}.dividendExempt`,
    defaultMessage: "Dividendo exento",
  },
  fee: {
    id: `${scope}.fee`,
    defaultMessage: "Comisiones",
  },
  interests: {
    id: `${scope}.interests`,
    defaultMessage: "Intereses",
  },
  journalEntry: {
    id: `${scope}.journalEntry`,
    defaultMessage: "Ingreso acciones",
  },
  optionAssignment: {
    id: `${scope}.optionAssignment`,
    defaultMessage: "Asignación opciones",
  },
  optionCorporateAction: {
    id: `${scope}.optionCorporateAction`,
    defaultMessage: "Opciones acción corporativa",
  },
  optionNonStandarContracts: {
    id: `${scope}.optionNonStandarContracts`,
    defaultMessage: "Opción para contratos no estándar",
  },
  optionExercise: {
    id: `${scope}.optionExercise`,
    defaultMessage: "Ejercicio opciones",
  },
  optionExpiration: {
    id: `${scope}.optionExpiration`,
    defaultMessage: "Expiración opciones",
  },
  optionTrade: {
    id: `${scope}.optionTrade`,
    defaultMessage: "Intercambio opciones",
  },
  mergerAcquisition: {
    id: `${scope}.mergerAcquisition`,
    defaultMessage: "Fusión/adquisición",
  },
  passThruChange: {
    id: `${scope}.passThruChange`,
    defaultMessage: "Coeficiente traspaso",
  },
  reorgCA: {
    id: `${scope}.reorgCA`,
    defaultMessage: "Acción corporativa",
  },
  stockSpinOff: {
    id: `${scope}.stockSpinOff`,
    defaultMessage: "Spinoff de acciones",
  },
  stockSplit: {
    id: `${scope}.stockSplit`,
    defaultMessage: "Split de acciones",
  },
  investmentAndRescue: {
    id: `${scope}.investmentAndRescue`,
    defaultMessage: "Inversiones y rescates",
  },
  movementsBetweenAccounts: {
    id: `${scope}.movementsBetweenAccounts`,
    defaultMessage: "Movimientos entre cuentas",
  },
  dividendNRA: {
    id: `${scope}.dividendNRA`,
    defaultMessage: "Retención dividendos (NRA)",
  },
});
